// triangulation using https://github.com/ironwallaby/delaunay
var TWO_PI = Math.PI * 2;

var images = [],
    imageIndex = 0;

var vertices = [],
    indices = [],
    fragments = [];

var container = null,
    section = null;

var image,
    imageWidth = null,
    imageHeight = null;

//TO DO -- Want to randomise this
var clickPosition = null;

var tl0 = null;
var canShatter = false;
var atTop = true;

var imageShattered = false,
    imagesPreloaded = false,
    shatterGenerated = false,
    throttle_timeout = 400,
    lastScrolled = 0,
    animating = false;

window.onload = function () {
    preloadImages(function () {
        imagesPreloaded = true;
        if (shatterGenerated == true) {
            shatterImage();
        }
        $('.js-image-preload, .js-bg-preload').removeClass('js-image-preload js-bg-preload');
        $('.js-preload-delayed').removeClass('js-preload-delayed').addClass('js-bg-preload');
        preloadImages(function () {
            $('.js-image-preload, .js-bg-preload').removeClass('js-image-preload js-bg-preload');
        });
    }, updateLoader);

    container = document.getElementById('shatter-container');
    section = document.getElementById('shatter-canvas');
    imageWidth = $(container).outerWidth();
    imageHeight = $(container).outerHeight();
    clickPosition = [imageWidth * 0.5, imageHeight * 0.5];

    TweenMax.set(container, {perspective: 1200});
    if (compatibilityCheck.isMobile() || compatibilityCheck.isIE([8, 9])) {
        shatterGenerated = true;
        shatter();
    } else {
        generateShatterElemements();
    }

};

$(window).resize(debounce(function () {
    generateShatterElemements();
}, 250));

function updateLoader(progress) {
    $('body').find('.preloader span').css('width', progress + '%');
}


function generateShatterElemements() {
    if (compatibilityCheck.isMobile() || compatibilityCheck.isIE([8, 9])) {
        return false;
    }
    vertices = [];
    indices = [];
    fragments = [];
    imageWidth = $(container).outerWidth();
    imageHeight = $(container).outerHeight();
    clickPosition = [imageWidth * 0.5, imageHeight * 0.5];
    html2canvas(container, {
        onrendered: function (canvas) {
            try {
                var img = canvas.toDataURL("image/png", 1.0);
                $('#shatter-obj').attr('src', img);
                image = new Image;
                image.src = img;
                triangulate();
                setTimeout(function () {
                    shatterGenerated = true;
                    shatter();
                });
            } catch (e) {
                shatterImage(true);
            }
        },
        letterRendering: true
    });
}

function triangulate() {
    vertices = [];
    var size = imageWidth * 1.8;
    var rings = [
            {r: 50, c: 12},
            {r: 250, c: 12},
            {r: 600, c: 12},
            {r: imageWidth, c: 12} // very large in case of corner clicks
        ],
        x,
        y,
        centerX = clickPosition[0],
        centerY = clickPosition[1];

    vertices.push([centerX, centerY]);

    rings.forEach(function (ring) {
        var radius = ring.r,
            count = ring.c,
            variance = radius * 0.25;

        for (var i = 0; i < count; i++) {
            x = Math.cos((i / count) * TWO_PI) * radius + centerX + randomRange(-variance, variance);
            y = Math.sin((i / count) * TWO_PI) * radius + centerY + randomRange(-variance, variance);
            vertices.push([x, y]);
        }
    });

    vertices.forEach(function (v) {
        v[0] = clamp(v[0], 0, imageWidth);
        v[1] = clamp(v[1], 0, imageHeight);
    });

    indices = Delaunay.triangulate(vertices);
}

function shatter() {
    if (compatibilityCheck.isMobile() || compatibilityCheck.isIE([8, 9])) {
        canShatter = true;
        if (imagesPreloaded == true) {
            shatterImage();
        }
    } else {
        $('#shatter-canvas').html('');
        var p0, p1, p2,
            fragment;

        tl0 = new TimelineMax({onComplete: shatterCompleteHandler, onReverseComplete: reverseShatterCompleteHandler});

        for (var i = 0; i < indices.length; i += 3) {
            p0 = vertices[indices[i + 0]];
            p1 = vertices[indices[i + 1]];
            p2 = vertices[indices[i + 2]];

            fragment = new Fragment(p0, p1, p2);

            var dx = fragment.centroid[0] - clickPosition[0],
                dy = fragment.centroid[1] - clickPosition[1],
                d = Math.sqrt(dx * dx + dy * dy),
                rx = 30 * sign(dy),
                ry = 90 * -sign(dx),
                delay = d * 0.003 * randomRange(0.2, 0.3);
            fragment.canvas.style.zIndex = Math.floor(d).toString();

            var tl1 = new TimelineMax();

            tl1.to(fragment.canvas, 1, {
                z: -500,
                rotationX: rx,
                rotationY: ry,
                ease: Cubic.easeIn
            });
            tl1.to(fragment.canvas, 0.4, {alpha: 0}, 0.6);

            tl0.insert(tl1, delay);

            fragments.push(fragment);
            section.appendChild(fragment.canvas);
            tl0.stop();
            if (imageShattered) {
                tl0.progress(1).play();
            }
        }
        canShatter = true;
        if (imagesPreloaded == true && !$('body').is('.show-navigation')) {
            shatterImage();
        }
    }
}

function shatterCompleteHandler() {
    $('body').addClass('hide-canvas');
    imageShattered = true;
    animating = false;
}

function reverseShatterCompleteHandler() {
    $('.shatter').removeClass('shatter');
    imageShattered = false;
    animating = false;
}

//////////////
// MATH UTILS
//////////////

function randomRange(min, max) {
    return min + (max - min) * Math.random();
}

function clamp(x, min, max) {
    return x < min ? min : (x > max ? max : x);
}

function sign(x) {
    return x < 0 ? -1 : 1;
}

//////////////
// FRAGMENT
//////////////

Fragment = function (v0, v1, v2) {
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;

    this.computeBoundingBox();
    this.computeCentroid();
    this.createCanvas();
    this.clip();
};
Fragment.prototype = {
    computeBoundingBox: function () {
        var xMin = Math.min(this.v0[0], this.v1[0], this.v2[0]),
            xMax = Math.max(this.v0[0], this.v1[0], this.v2[0]),
            yMin = Math.min(this.v0[1], this.v1[1], this.v2[1]),
            yMax = Math.max(this.v0[1], this.v1[1], this.v2[1]);

        this.box = {
            x: xMin,
            y: yMin,
            w: xMax - xMin,
            h: yMax - yMin
        };
    },
    computeCentroid: function () {
        var x = (this.v0[0] + this.v1[0] + this.v2[0]) / 3,
            y = (this.v0[1] + this.v1[1] + this.v2[1]) / 3;

        this.centroid = [x, y];
    },
    createCanvas: function () {
        this.canvas = document.createElement('canvas');
        this.canvas.width = this.box.w;
        this.canvas.height = this.box.h;
        this.canvas.style.width = this.box.w + 'px';
        this.canvas.style.height = this.box.h + 'px';
        this.canvas.style.left = this.box.x + 'px';
        this.canvas.style.top = this.box.y + 'px';
        this.ctx = this.canvas.getContext('2d');
    },
    clip: function () {
        this.ctx.translate(-this.box.x, -this.box.y);
        this.ctx.beginPath();
        this.ctx.moveTo(this.v0[0], this.v0[1]);
        this.ctx.lineTo(this.v1[0], this.v1[1]);
        this.ctx.lineTo(this.v2[0], this.v2[1]);
        this.ctx.closePath();
        this.ctx.clip();
        this.ctx.drawImage(image, 0, 0);
    }
};

function shatterImage(immediate) {
    $(window).scroll();
    $('.preloader').addClass('hidden');
    $('#shatter-container').parent().addClass('shatter');
    $('body').addClass('shattered no-arrow');
    animating = true;
    if (!compatibilityCheck.isMobile() && !compatibilityCheck.isIE([8, 9]) && tl0) {
        tl0.play();
    } else {
        setTimeout(function () {
            shatterCompleteHandler();
        }, immediate ? 0 : 1600);
    }
    setTimeout(function () {
        $('.js-animate[data-manual-trigger="true"]').addClass('play');
        $('button.navigation-button').removeClass('hidden');
        if (typeof $('body').attr('data-no-remove') == 'undefined') {
            $('body').removeClass('no-scroll');
        }
    }, immediate ? 0 : 1600);
}

function reconstructImage() {
    $('body').removeClass('shattered hide-canvas');
    animating = true;
    if (!compatibilityCheck.isMobile() && !compatibilityCheck.isIE([8, 9])) {
        tl0.reverse();
    } else {
        reverseShatterCompleteHandler();
    }
}

function throttle(fn, threshhold, scope) {
    threshhold || (threshhold = 250);
    var last,
        deferTimer;
    return function () {
        var context = scope || this;

        var now = +new Date,
            args = arguments;
        if (last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn.apply(context, args);
            }, threshhold);
        } else {
            last = now;
            fn.apply(context, args);
        }
    };
}